import React from "react";
import "./SplashScreen.css"
import icon from "../../resouces/explainit-splash-icon.svg"
import Footer from "../Footer";


export default class SplashScreen extends React.Component {

    render() {
        return (
            <div className="SplashScreen">
                <img className="centered" src={icon} alt=""/>

                <Footer />
            </div>
        )
    }
}